import React from 'react';
import PageRoutes from './components/Page/PageRoutes';
import { useResource } from './hooks';

function App() {
  const [
    isLoading,
    isLoaded,
    isSingle
  ] = useResource();

  return (
    <div className={`app ${isSingle ? 'app-is-single' : ''}`}>
      {isLoading && <div>Loading...</div>}
      {isLoaded && <PageRoutes />}
    </div>
  );
}

export default App;
